<h2>Inzidenz </h2>
<div class="inzcontainer">
    <div class="inzidenzwrapper">
        <span class="inzidenzspan">Aktueller Inzidenzwert </span>
        <span class="curentinzidenz">
            {{(currentRegionData?.inzidenzauto ?
            currentRegionData?.inzidenzLand :
            currentRegionData?.inzidenz) | number}} </span>
    </div>
    <ng-container *ngIf="chartOption">
        <div class="inzidenzwrapper fromtop">
            <span class="inzidenzspan">Statistik 📉 der letzten Wochen </span>
            <div id="inzidenzcharts" class="chart"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentRegionData.ampelcolor?.length > 0">
        <div class="inzidenzwrapper">
            <span class="inzidenzspan fromtop">
                Tendenzampel
                <mat-icon aria-label="true" [matTooltip]="inzidenzInfoAmpel" class="infoi" matTooltipClass="matTooltip"
                    #toolinzidenzInfoAmpel="matTooltip"
                    (click)="toolinzidenzInfoAmpel.toggle();$event.stopPropagation();">
                    info</mat-icon>
            </span>

            <div class="ampelwrapper">
                <mat-icon aria-label="true" class="ampelclasse" style="color: red;"
                    [style.opacity]="currentRegionData.ampelcolor === 'red' ? '1' : '.2'">
                    circle</mat-icon>
                <mat-icon aria-label="true" class="ampelclasse" style="color: orange;"
                    [style.opacity]="currentRegionData.ampelcolor === 'orange' ? '1' : '.2'">
                    circle</mat-icon>
                <mat-icon aria-label="true" class="ampelclasse" style="color: green;"
                    [style.opacity]="currentRegionData.ampelcolor === 'green' ? '1' : '.2'">
                    circle</mat-icon>
            </div>
        </div>
    </ng-container>
</div>
<span style="margin-top: .3rem;font-size: .75rem;font-style: italic;"> Die
    7-Tage-Inzidenz ist eine wichtige Grundlage für die Einschätzung der Entwicklung der
    Corona-Pandemie. Der Wert bildet die Fälle pro 100.000 Einwohner*innen in den
    letzten 7 Tagen ab.</span>